import { render } from "./Or_fileupload.vue?vue&type=template&id=2add4542&scoped=true&ts=true"
import script from "./Or_fileupload.vue?vue&type=script&lang=ts"
export * from "./Or_fileupload.vue?vue&type=script&lang=ts"

import "./Or_fileupload.vue?vue&type=style&index=0&id=2add4542&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2add4542"]])

export default __exports__